import {useEffect, useRef} from 'react';

/** Runs `apply` once per distinct `key` — skips null keys and never re-fires for a key already applied. */
export function useApplyOnce(key: string | null, apply: () => void): void {
  const appliedKeyRef = useRef<string | null>(null);
  const applyRef = useRef(apply);
  applyRef.current = apply;

  useEffect(() => {
    if (key === null || appliedKeyRef.current === key) return;
    appliedKeyRef.current = key;
    applyRef.current();
  }, [key]);
}
